import React from 'react'
//=======Material UI
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import useTerminateProjectEditAfterReview from './useTerminateProjectEditAfterReview'
import Researcher from './researcher/researcher'
import Officer from './officer/officer'
import useCheckPermission from '../../../../../utilities/checkPermission'
import Dialog from '../../../../../control/dialog/dialog'
import useTranslate from '../../../../../i18n/useTranslate'
import Button from '../../../../../control/button/button'
import constSubmittedStep from '../../../../../constants/submittedStep'
import submittedStatus from '../../../../../constants/submittedStatus'
import ButtonSubmittedWithdraw from '../../page/_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'

type TerminateProjectEditAfterReviewViewType = ReturnType<typeof useTerminateProjectEditAfterReview> &
    Omit<TerminateProjectEditAfterReview, 'projectMode'>
const TerminateProjectEditAfterReviewView: React.FC<TerminateProjectEditAfterReviewViewType> = (props) => {
    const {
        projectMode,
        configDialog,
        isViewMode,
        projectData,
        onRefDialog,
        onCallbackSaveComplete,
        onClickBackToSearch,
    } = props
    const checkPermission = useCheckPermission()
    const isUserResearcher = checkPermission.isUserResearcher()
    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)

    const isBtnClose =
        checkPermission.isUserChairman() &&
        projectData?.stepID === constSubmittedStep.sign &&
        projectData?.submittedStatusInfo?.value !== submittedStatus.complete
            ? false
            : isViewMode

    const renderUserRoleComponent = () => {
        if (isUserResearcher) {
            return <Researcher projectMode={projectMode} callbackSaveComplete={onCallbackSaveComplete} />
        } else {
            return <Officer callbackSaveComplete={onCallbackSaveComplete} />
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid container item>
                {renderUserRoleComponent()}
            </Grid>

            {isBtnClose && !canUpdateDocument ? (
                <Grid container item justify="space-between" spacing={2}>
                    <Grid item xs={12} sm={'auto'}>
                        <ButtonSubmittedWithdraw gridProps={{ xs: false }} fullWidth={isMobileView ? true : false} />
                    </Grid>
                    <Grid item xs={12} sm={'auto'}>
                        <Button color="primary" onClick={onClickBackToSearch} fullWidth={isMobileView ? true : false}>
                            {translate.get('BUTTON.CLOSE')}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}
            <Dialog onRef={onRefDialog} {...configDialog} />
        </Grid>
    )
}

export type TerminateProjectEditAfterReview = {
    projectMode: 'CREATE' | 'EDIT'
}
const TerminateProjectEditAfterReview: React.FC<TerminateProjectEditAfterReview> = (props) => {
    const terminateProjectEditAfterReviewModel = useTerminateProjectEditAfterReview(props)

    return <TerminateProjectEditAfterReviewView {...terminateProjectEditAfterReviewModel} />
}
export default TerminateProjectEditAfterReview
